import Annotate from "./Annotate";
import CurrentReadingGroup from "./CurrentReadingGroup";
import Highlight from "./Highlight";
import Notate from "./Notate";
import Share from "./Share";

export default {
  Annotate,
  CurrentReadingGroup,
  Highlight,
  Notate,
  Share
};
